import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-logo',
  standalone: true,
  imports: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './logo.component.html',
})
export class LogoComponent {
  @Input() widthInPx: number = 120;
  /** Small label under the wordmark, e.g. "Networks" for Verbund accounts. */
  @Input() subtitle: string | null = null;
}
